'use strict';

define('interactive-survey',['jquery', 'jquery-waypoints', 'jquery-waypoints-sticky'], function ($) {
  var $answer = $('.answer');
  var $answers = $('.answers');
  var $yourAnswer = $('.your-answer-wrapper');
  var $questionnaire = $('.questionnaire');

  var initialize = function() {
    $('.btn-readmore').click(function() {
      //Read more button with toggle (Only shown on mobile!)
      var $this = $(this);
      $this.addClass('hidden-mobile');
      $this.siblings('.extend').addClass('show animation');
      //Scroll to .description
      $('html, body').animate({scrollTop: $this.closest( '.description' ).offset().top -120 }, 'slow');
    });

    $('.answer').click(function() {
      var $this = $(this);
      var data = $this.data('answer');
      var $resultWrap = $this.parents('.question-wrapper').siblings('.result-wrapper');

      if($this.children().length > 0) {
        //Multi picker
        if($this.children('.answer-checkbox').is(':checked') === true) {
          //Add item as selected
          $this.addClass('selected');
        } else {
          //Remove selection
          $this.removeClass('selected');
        }
      } else {
        if($this.data('multi') === true) {
          var found = false;
          $this.parent('.answers').children().find('input[type=checkbox]').each(function() {
            if ($(this).is(":checked")) {
              found = true;
              $resultWrap.children().find($yourAnswer).append('<div class=" your-answer answer result">' + $(this).parent().data('answer') + '</div>');
            }
          });

          if(!found) {
            $resultWrap.children().find('.your-answer-wrapper').addClass('hidden');
          }
        } else {
          //Single picker
          if(data) {
            $resultWrap.children().find($yourAnswer).append('<div class=" your-answer answer result">' + data + '</div>');
          } else {
            $resultWrap.children().find('.your-answer-wrapper').addClass('hidden');
          }
        }

        $this.closest( $answers ).addClass('hidden');
        $resultWrap.addClass('show animation');
        $this.parents('.questionnaire').addClass('no-padding');

        $('html, body').animate({scrollTop: $this.closest( $questionnaire ).offset().top -175 }, 'slow');
      }
    });
  };
  return {
    init: initialize
  };
});
